import { useState, useEffect } from 'react';
import '@/types/telegram';

interface Environment {
  isTelegram: boolean;
  isPWA: boolean;
  isIOS: boolean;
  isSafari: boolean;
  isDesktop: boolean;
}

export function useEnvironment(): Environment {
  const [environment, setEnvironment] = useState<Environment>({
    isTelegram: false,
    isPWA: false,
    isIOS: false,
    isSafari: false,
    isDesktop: false,
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    // Detect Telegram
    const isTelegram = !!window.Telegram?.WebApp?.initData;

    // Detect PWA (standalone mode)
    const isPWA =
      window.matchMedia('(display-mode: standalone)').matches ||
      // @ts-expect-error - standalone is a Safari-specific property
      window.navigator.standalone === true;

    // Detect iOS
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(userAgent);

    // Detect Safari (excluding Chrome on iOS which also has "Safari" in UA)
    const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent) && !isTelegram; // Telegram webview might look like Safari but we treat it separately

    // Detect Desktop (rough approximation)
    const isDesktop = !/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
      userAgent
    );

    setEnvironment({
      isTelegram,
      isPWA,
      isIOS,
      isSafari,
      isDesktop,
    });
  }, []);

  return environment;
}
